import React, { useState } from "react";
import {
  MAX_ALLOWED_QUESTIONS,
  useRequestQuestionsAI,
} from "../../../../contexts/api/question-group/requestQuestionsAI";
import { useSnackbar } from "../../../../contexts/ui";
import { InputField } from "../../../UI";
import { ModalActionButton } from "../../../UI/Button";
import { Loading } from "../../../UI/Loaders";
import { useBulkCreateQuestions } from "../../../../contexts/api/question-group/bulkCreateQuestions";

export function GenerateQuestionsModal({ questionGroupId, onCancel }) {
  const { showSnackbar } = useSnackbar();

  const [prompt, setPrompt] = useState("");
  const [numQuestions, setNumberOfQuestions] = useState("5");

  const { loading: generatingQuestions, requestQuestionsAI } =
    useRequestQuestionsAI();

  const { loading: persistingQuestions, bulkCreateQuestions } =
    useBulkCreateQuestions();

  const refreshPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 250);
  };

  const handleSumbit = async () => {
    // Step 1: Request AI-generated Questions
    const generationResult = await requestQuestionsAI({
      numQuestions,
      prompt,
    });

    if (!generationResult.success) {
      showSnackbar(
        "Error generating questions: " + generationResult.errorMessage,
        "error",
      );
      return;
    }

    // Step 2: Persist AI-generated Questions
    const persistenceResult = await bulkCreateQuestions(
      questionGroupId,
      generationResult.questions,
    );

    if (!persistenceResult.success) {
      showSnackbar(
        "Error persisting generated questions: " +
          persistenceResult.errorMessage,
        "error",
      );
      return;
    }

    // Step 3: Show success feedback
    showSnackbar("Questions created successfully!", "success");

    // Step 4: Refresh the page to show updated questions
    refreshPage();
  };

  const isLoading = generatingQuestions || persistingQuestions;

  return (
    <div>
      Instructions:
      <InputField
        id="generate-questions-input-field"
        placeholder="Type the AI prompt to generate questions here..."
        type="textarea"
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        inputConfig={{
          value: prompt,
          style: {
            height: "200px",
          },
        }}
      />
      <div>
        How many questions would you like to generate?
        <InputField
          type="number"
          step="1"
          min="-10"
          max={MAX_ALLOWED_QUESTIONS}
          value={numQuestions}
          onChange={(e) => setNumberOfQuestions(e.target.value)}
        />
      </div>
      <div className="modal-footer" style={{ marginBottom: "-40px" }}>
        <ModalActionButton disabled={isLoading} onClick={handleSumbit}>
          {isLoading ? <Loading height="10px" /> : "Submit"}
        </ModalActionButton>
        <ModalActionButton ghost onClick={onCancel}>
          Cancel
        </ModalActionButton>
      </div>
    </div>
  );
}
